import React from "react";
import { useSelector } from "react-redux";

import { AaaGameInformationConceptDetailsDataType } from "../../../../models/forms";
import { getGenres } from "../../../../redux/selectors";
import { FieldOption } from "../../../../server/crm/api/models/forms";
import { getDateStringForReadOnlyForm, ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyAaaConceptDetailProps = {
  dataInForm: AaaGameInformationConceptDetailsDataType;
};

const AaaConceptDetailConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["gameTitle", {}],
  ["codeName", {}],
  [
    "genre",
    {
      mapper: (
        data: AaaGameInformationConceptDetailsDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const crmGenresList = additionalData.get("crmGenresList") as FieldOption[];
        return crmGenresList.find(genreItem => genreItem.id === data.genre)?.value;
      },
    },
  ],
  [
    "targetReleaseDate",
    {
      title: "targetReleaseDate",
      mapper: (data: AaaGameInformationConceptDetailsDataType) =>
        getDateStringForReadOnlyForm(data.targetReleaseDate),
    },
  ],
  [
    "gameDevelopers",
    {
      title: "gameDeveloper",
    },
  ],
  [
    "hook",
    {
      title: "theHook",
    },
  ],
  [
    "gameplayVideosLinks",
    {
      title: "gameplayVideo",
    },
  ],
  [
    "gameplayDetails",
    {
      title: "gameplayDetailsAndSummary",
    },
  ],
  ["gameBuildLinks", {}],
  ["gameBuildKeys", {}],
  [
    "additionalLinks",
    {
      isAnswerWithHtmlContent: true,
    },
  ],
]);

export const ReadOnlyAaaConceptDetail = ({ dataInForm }: ReadOnlyAaaConceptDetailProps) => {
  const crmGenresList = useSelector(getGenres);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["crmGenresList", crmGenresList]]);
  return (
    <ReadOnlyForm
      formConfig={AaaConceptDetailConfig}
      formData={dataInForm}
      additionalData={additionalData}
    />
  );
};
